// tslint:disable: variable-name
import { BaseResourceModel } from '../../models/base-resource.model';

export class BaseNacional extends BaseResourceModel {
    constructor(
        public id?: number,
        public descricao?: string,
        public codigo?: string,
        public tipo?: 'catmat' | 'obm',
        public numero?: string
    ) {
        super();
    }

    static converteJson(json: any): BaseNacional {
        return Object.assign(new BaseNacional(), json);
    }
}
